module.exports = __webpack_public_path__ + "static/media/website-10.96249214.mp4";